const SsoConnectionKeys = {
  all: ['SsoConnections'] as const,
  lists: () => [...SsoConnectionKeys.all, 'list'] as const,
  list: (queryParams: string) => [...SsoConnectionKeys.lists(), { queryParams }] as const,
  details: () => [...SsoConnectionKeys.all, 'detail'] as const,
  detail: (id: string) => [...SsoConnectionKeys.details(), id] as const,
};

export { SsoConnectionKeys };
